import { Form, Formik } from 'formik'
import moment from 'moment'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../../../../components/buttons/buttons.component'
import PeriodInputs from '../../../../../components/form-components/period-inputs.component'
import { SelectInput } from '../../../../../components/form-components/inputs.component'
import Browser from '../../../../../services/Browser'

const StyledGridContainer = styled.div`
	display: ${Browser.isInternetExplorer() ? 'flex' : 'grid'};
	justify-content: ${Browser.isInternetExplorer() ? 'space-between' : ''};
	grid-gap: 15px;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

	${Browser.isInternetExplorer()
		? `#period {
		width: 200px;
	}
	
	#transactionType {
		width: 200px;
	}
	`
		: ''}
`

const StyledButtonContainer = styled.div`
	display: ${Browser.isInternetExplorer() ? 'flex' : 'grid'};
	justify-content: end;
	padding-top: 2.7rem;
`

class SearchForm extends Component {
	constructor(props) {
		super(props)

		this.state = {
			period: '30',
			initialDate: moment()
				.add(-30, 'd')
				.format('DD/MM/YYYY'),
			finalDate: moment().format('DD/MM/YYYY'),
			transactionType: 'none'
		}
	}

	componentDidMount() {
		const { onSubmit } = this.props
		setTimeout(() => {
			onSubmit(this.refs.form.state.values)
		}, 0)
	}

	render() {
		const { onSubmit } = this.props
		const { initialDate, finalDate } = this.state
		return (
			<Formik
				ref={'form'}
				initialValues={this.state}
				onSubmit={onSubmit}
				render={props => (
					<Form className="form" noValidate>
						<StyledGridContainer>
							<PeriodInputs
								initialDate={initialDate}
								finalDate={finalDate}
								{...props}
							/>

							<SelectInput
								id="transactionType"
								label="Tipo de transação"
								defaultValue={transactionTypeOptions[0]}
								options={transactionTypeOptions}
								multi={false}
								{...props}
							/>
						</StyledGridContainer>
						<StyledButtonContainer>
							<Button primary type="submit">
								Consultar
							</Button>
						</StyledButtonContainer>
					</Form>
				)}
			/>
		)
	}
}

const transactionTypeOptions = [
	{ value: 'none', label: 'Todos' },
	{ value: 'Accumulation', label: 'Acúmulo de pontos' },
	{ value: 'Used', label: 'Resgate de pontos' },
	{ value: 'Expired', label: 'Expiração de pontos' }
]

export default SearchForm
